<app-status-bar></app-status-bar>

<div class="reservas-list-wrapper">
  <div class="header-wrapper">
    <div class="back-button" (click)="goBack()">
      <fa-icon [icon]="faArrowLeft"></fa-icon>
      <p>Volver</p>
    </div>
  </div>

  <div class="content-wrapper">
    <!-- Título + botón nueva reserva -->
    <div class="content-header-wrapper">
      <p class="title">Reservas</p>
      <button class="new-reservation-btn" (click)="openNewForm()">
        <fa-icon [icon]="faPlus"></fa-icon>
        <span>Nueva reserva</span>
      </button>
    </div>

    <!-- Buscador + Filtros -->
    <div class="filters-wrapper">
      <div class="searchbar">
        <i class="fal fa-search"></i>
        <input
          type="text"
          placeholder="Buscar por nombre..."
          [(ngModel)]="searchName"
          (ngModelChange)="onSearchChange()"
        />
        <i class="fal fa-times clear-inline" *ngIf="searchName" (click)="searchName=''; onSearchChange()"></i>
      </div>
      <div class="filter-multiselect" (clickOutside)="closeStatusDropdown()">
        <button class="multiselect-trigger" (click)="toggleStatusDropdown()" [class.active]="filterStatus !== ''">
          <i class="fa-regular fa-layer-group"></i>
          <span>{{ statusFilterLabel }}</span>
          <i class="fa-regular fa-chevron-down chevron" [class.open]="statusDropdownOpen"></i>
        </button>
        <div class="multiselect-panel" *ngIf="statusDropdownOpen">
          <div *ngFor="let opt of statusOptions" class="multiselect-option single"
               [class.selected]="filterStatus === opt.value"
               (click)="selectStatus(opt.value)">
            <span>{{ opt.label }}</span>
          </div>
        </div>
      </div>
      <div class="filter-multiselect" *ngIf="availableEvents.length > 0" (clickOutside)="closeEventDropdown()">
        <button class="multiselect-trigger" (click)="toggleEventDropdown()" [class.active]="filterEventIds.length > 0">
          <i class="fa-regular fa-calendar-days"></i>
          <span>{{ eventFilterLabel }}</span>
          <i class="fa-regular fa-chevron-down chevron" [class.open]="eventDropdownOpen"></i>
        </button>
        <div class="multiselect-panel" *ngIf="eventDropdownOpen">
          <div class="panel-search">
            <i class="fal fa-search"></i>
            <input type="text" placeholder="Buscar evento..." [(ngModel)]="eventSearch" (click)="$event.stopPropagation()">
            <i class="fal fa-times panel-search-clear" *ngIf="eventSearch" (click)="eventSearch = ''; $event.stopPropagation()"></i>
          </div>
          <label *ngFor="let ev of filteredAvailableEvents" class="multiselect-option">
            <input type="checkbox" [checked]="filterEventIds.includes(ev.id)" (change)="toggleEventFilter(ev.id)">
            <span>{{ ev.title }}</span>
          </label>
          <div class="panel-empty" *ngIf="filteredAvailableEvents.length === 0">Sin resultados</div>
        </div>
      </div>
      <button class="btn-clear-filters"
        *ngIf="filterStatus || filterEventIds.length"
        (click)="clearFilters()">
        <i class="fa-regular fa-times"></i>
        <span>Limpiar filtros</span>
      </button>
    </div>

    <!-- Formulario nueva reserva (inline) -->
    <div class="new-reservation-form" *ngIf="showNewForm">
      <div class="form-card">
        <p class="form-title">Nueva reserva</p>
        <div class="form-fields">
          <div class="field-group">
            <label>Nombre de la reserva *</label>
            <input
              type="text"
              placeholder="Ej: Grupo colegio, Evento empresa..."
              [(ngModel)]="newReservationName"
              (keyup.enter)="createReservation()"
              autofocus
            />
          </div>
        </div>
        <div class="form-actions">
          <button class="btn-cancel" (click)="cancelNewForm()">Cancelar</button>
          <button
            class="btn-create"
            [disabled]="!newReservationName?.trim() || savingReservation"
            (click)="createReservation()"
          >
            <span *ngIf="!savingReservation">Crear reserva</span>
            <span *ngIf="savingReservation">Creando...</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Loading spinner -->
    <div class="loading-wrapper" *ngIf="loading">
      <mat-progress-spinner color="accent" mode="indeterminate" diameter="50">
      </mat-progress-spinner>
    </div>

    <!-- Sin reservas -->
    <div class="empty-state" *ngIf="!loading && reservations.length === 0">
      <fa-icon [icon]="faBookmark" class="empty-icon"></fa-icon>
      <p class="empty-title">No hay reservas creadas</p>
      <p class="empty-subtitle">
        Crea una nueva reserva para empezar a añadir entradas o asientos.
      </p>
      <button class="new-reservation-btn" (click)="openNewForm()">
        <fa-icon [icon]="faPlus"></fa-icon>
        <span>Nueva reserva</span>
      </button>
    </div>

    <!-- Tabla de reservas -->
    <div class="reservations-table" *ngIf="!loading && reservations.length > 0">
      <div class="table-header">
        <span class="col-name">Nombre</span>
        <span class="col-lines">Entradas</span>
        <span class="col-total">Total</span>
        <span class="col-status">Estado</span>
        <span class="col-next-event">Próximo evento</span>
        <span class="col-date">Creada</span>
      </div>
      <div
        class="table-row"
        *ngFor="let res of reservations"
        (click)="goToDetail(res.id)"
      >
        <span class="col-name">
          <fa-icon [icon]="faBookmark" class="row-icon"></fa-icon>
          {{ res.name }}
        </span>
        <span class="col-lines">{{ res.cart?.cart_lines?.length ?? 0 }}</span>
        <span class="col-total">
          {{ getReservationTotal(res) | number:'1.2-2' }} &euro;
        </span>
        <span class="col-status">
          <span class="status-badge" [class]="res.cart?.status?.name || 'pending'">
            {{ getStatusLabel(res.cart?.status?.name) }}
          </span>
        </span>
        <span class="col-next-event">
          {{ res.next_session_date ? (res.next_session_date | date:'dd MMM yyyy · HH:mm':'+0000') + 'h' : '—' }}
        </span>
        <span class="col-date">{{ res.created_at | date: "dd/MM/yyyy" }}</span>
      </div>
    </div>

    <!-- Paginación -->
    <div class="pagination-wrapper" *ngIf="!loading && reservations.length > 0">
      <span class="pagination-count">Mostrando {{ reservations.length }} de {{ totalReservations }} reservas</span>
      <button class="btn-load-more" *ngIf="hasMorePages" [disabled]="loadingMore" (click)="loadMore()">
        <span *ngIf="!loadingMore">Cargar más</span>
        <span *ngIf="loadingMore">Cargando...</span>
      </button>
    </div>
  </div>
</div>
